module.exports = __webpack_public_path__ + "static/img/icomoon.f7021d4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/otherIcon/fonts/icomoon.svg?b7i6dh
// module id = cJTC
// module chunks = 71